var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderOpenRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2650_26870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3125 13.7883H12.625C12.9367 13.7883 13.2238 13.6243 13.3797 13.3536L16.4422 8.10356C16.6008 7.83286 16.6008 7.49927 16.4449 7.22583C16.2891 6.95239 16.002 6.78833 15.6875 6.78833H4.75C4.43828 6.78833 4.15117 6.95239 3.99531 7.2231L2.125 10.4278V3.28833C2.125 3.04771 2.32187 2.85083 2.5625 2.85083H5.77539C5.89023 2.85083 6.00234 2.89731 6.08437 2.97935L6.80898 3.70395C7.3832 4.27817 8.1625 4.60083 8.97461 4.60083H12.1875C12.4281 4.60083 12.625 4.79771 12.625 5.03833V5.91333H13.9375V5.03833C13.9375 4.0731 13.1527 3.28833 12.1875 3.28833H8.97461C8.50977 3.28833 8.06406 3.10513 7.73594 2.777L7.01133 2.04966C6.6832 1.72153 6.2375 1.53833 5.77266 1.53833H2.5625C1.59727 1.53833 0.8125 2.3231 0.8125 3.28833V12.0383C0.8125 13.0036 1.59727 13.7883 2.5625 13.7883H3.21055H11.3125Z",
    fill: "#313131"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2650_26870"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.75,
    height: 14,
    fill: "white",
    transform: "translate(0.8125 0.66333)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpenRegular);
export default __webpack_public_path__ + "static/media/folder-open-regular.8e6f1a1ab34dc7eefa7ab3157ed18417.svg";
export { ForwardRef as ReactComponent };